module.exports = __webpack_public_path__ + "static/img/paixu3.1ad3816.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/paixu3.png
// module id = jIDX
// module chunks = 5